import { gsap } from 'gsap';

document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('.partners__list')) {
    if (window.innerWidth < 980) {
      partnersSlider();
    }
  }
});

function partnersSlider() {
  const partnersList = document.querySelector('.partners__list');
  const container = partnersList.parentElement;

  function autoScroll() {
    gsap.to(partnersList, {
      duration: 15, // Set the duration of the scroll (adjust as needed)
      x: -partnersList.scrollWidth + container.offsetWidth,
      ease: 'linear',
      onComplete: () => {
        gsap.set(partnersList, { x: container.offsetWidth });
        autoScroll();
      },
    });
  }

  // Start automatic scrolling
  autoScroll();
}
